import { GOOGLE_MAP_ADDRESS, GOOGLE_MAP_STATIC_URL } from '../config'
import { message } from 'antd'
import { HERO_TYPE } from './constants'
import imageCompression from 'browser-image-compression'

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

export const getMapStaticUrl = (location) => {
  return GOOGLE_MAP_STATIC_URL.replace(/{LOCATION}/g, location)
}

export const getMapUrl = (location) => {
  return `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`
}

export const getAddressFromLocation = async (location) => {
  const response = await fetch(
    GOOGLE_MAP_ADDRESS.replace(/{LOCATION}/g, location)
  )

  if (response.ok) {
    const json = await response.json()

    if (json.status !== 'ZERO_RESULTS') {
      return json.results[0].formatted_address
    }
  } else {
    return 'No location'
  }
}

export const getQuantityLabel = (quantity) => {
  switch (quantity) {
    case 'NO_LIMIT':
      return 'ไม่กำหนด'
    case 'UNIT_10':
      return '> 10 กก.'
    case 'UNIT_100':
      return '> 100 กก.'
    case 'UNIT_1000':
      return '> 1000 กก.'
    default:
      return ''
  }
}

export const getHeroType = (heroType) => {
  const hero = {
    RECYCLE_SHOP: {
      title: 'ร้านรับซื้อขยะรีไซเคิล',
      icon: require('../assets/icons/icon_recycle_shop.svg')
    },
    SCOOTER: {
      title: 'รถรับซื้อขยะรีไซเคิล',
      icon: require('../assets/icons/icon_scooter.svg')
    },
    DROP_POINT: {
      title: 'จุดรับบริจาคขยะรีไซเคิล',
      icon: require('../assets/icons/icon_drop_point.svg')
    },
    POSTAL: {
      title: 'รับขยะรีไซเคิลทางพัสดุ',
      icon: require('../assets/icons/icon_postal.svg')
    },
    CIRCULAR_BIN: {
      title: 'Circular Bin',
      icon: require('../assets/icons/icon_circular_bin.svg')
    },
    USER: {
      title: 'User',
      icon: require('../assets/icons/icon_user.png')
    }
  }

  return hero[heroType]
}

export function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!')
  }
  return false
}

export function getPlaceholderName(index) {
  if (index === 0) {
    return 'ถังขยะทั่วไป'
  } else {
    return 'ถังพลาสติกยืด, ถังส่งโครงการวน'
  }
}

export function getPlaceholderDetail(index) {
  if (index === 0) {
    return 'ล้างให้สะอาด, แยกเศษอาหารก่อนทิ้ง'
  } else {
    return 'ล้างให้สะอาด, พับก่อนทิ้ง'
  }
}

export function getStatus(heroType, type) {
  if (heroType === HERO_TYPE.CIRCULAR_BIN) {
    return `${type === 'open' ? 'เปิด' : 'ปิด'}รับวัสดุรีไซเคิล`
  } else {
    return `${type === 'open' ? 'เปิด' : 'ปิด'}รับซื้อวัสดุรีไซเคิล`
  }
}

export function getMenu(heroType) {
  if (heroType === HERO_TYPE.CIRCULAR_BIN) {
    return 'เปิด/ปิด Circular Bin'
  } else {
    return 'เปิด/ปิดรับซื้อวัสดุรีไซเคิล'
  }
}

export async function compressFile(file) {
  const options = {
    maxSizeMB: 0.8,
    useWebWorker: false
  }

  const compressedFile = await imageCompression(file, options)
  return new File([compressedFile], compressedFile.name, {
    type: compressedFile.type
  })
}

export function toBuddhistYear(moment, format) {
  const christianYear = moment.format('YYYY')
  const buddhishYear = (parseInt(christianYear, 10) + 543).toString()
  return moment
    .format(
      format
        .replace('YYYY', buddhishYear)
        .replace('YY', buddhishYear.substring(2, 4))
    )
    .replace(christianYear, buddhishYear)
}



// WEBPACK FOOTER //
// ./src/utils/index.js